import { get, post, del } from './http';

export function contribution(data, context) {
  return post(context, '/contribution', data);
}

export function picContribution(data, context) {
  return post(context, '/contribution/pic', data);
}

export function scheduleContribution(data, context) {
  return post(context, '/contribution/schedule', data);
}

export function contributionsById(id, data, context) {
  return get(context, `contributions/${id}`, data);
}

export function hasContributions(id, context) {
  return get(context, `has/contributions/${id}`);
}

export function contributions(context) {
  return get(context, 'user/contributions');
}

export function deleteContribution(data, context) {
  return del(context, '/contribution', data); // type, playground
}
